import type { PanelProps } from "../panel-props"

import { clearAllFromStorage } from "../../../hooks/use-core-bookmarks"
import { Button } from "../../button"
import { SharedSettings } from "../shared-settings"

export function CoreBookmarksSettings({ closeSidebar }: PanelProps) {
  return (
    <SharedSettings closeSidebar={closeSidebar}>
      <section className="sidebar__section">
        <h3 className="sidebar__section-title">Actions</h3>
        <Button onClick={clearAllFromStorage} variant="destructive">
          clear all
        </Button>
      </section>
    </SharedSettings>
  )
}
